import React, { useEffect, useRef, useState } from 'react';
import { Calendar } from 'lucide-react';

const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return '';
    if (dateStr.includes('/')) return dateStr;
    const parts = String(dateStr).split('-');
    return parts.length === 3 ? `${parts[0]}/${parts[1]}/${parts[2]}` : dateStr;
};

export default function DatePickerWithFormat({
    value, onChange, label,
    required = false, disabled = false,
    placeholder = 'YYYY/MM/DD',
    className = '',
}) {
    const dateInputRef = useRef(null);
    const [displayValue, setDisplayValue] = useState('');

    useEffect(() => {
        setDisplayValue(formatDateForDisplay(value));
    }, [value]);

    const handleTextChange = (e) => {
        const input = e.target.value.replace(/\D/g, '');   // digits only
        let formatted = '';
        if (input.length > 0) {
            if (input.length <= 4) formatted = input;
            else if (input.length <= 6) formatted = `${input.slice(0, 4)}/${input.slice(4)}`;
            else formatted = `${input.slice(0, 4)}/${input.slice(4, 6)}/${input.slice(6, 8)}`;
        }
        setDisplayValue(formatted);

        const parts = formatted.split('/');
        if (parts.length === 3 && parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
            onChange(`${parts[0]}-${parts[1]}-${parts[2]}`);
        }
    };

    const openCalendar = () => {
        if (!disabled && dateInputRef.current) {
            dateInputRef.current.showPicker?.();
        }
    };

    return (
        <div>
            {label && (
                <label className="mb-1.5 block text-xs font-medium text-gray-700">
                    {label} {required && '*'}
                </label>
            )}
            <div className="relative">
                <input
                    ref={dateInputRef}
                    type="date"
                    className="absolute opacity-0 w-0 h-0 pointer-events-none"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={disabled}
                />
                <input
                    type="text"
                    className={className || 'w-full h-9 rounded-lg border border-gray-200 bg-white px-2.5 pr-8 text-xs text-gray-700 outline-none focus:border-primary-500'}
                    value={displayValue}
                    onChange={handleTextChange}
                    onClick={openCalendar}
                    placeholder={placeholder}
                    disabled={disabled}
                    maxLength={10}
                />
                <button
                    type="button"
                    onClick={openCalendar}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    disabled={disabled}
                    tabIndex={-1}
                >
                    <Calendar size={13} />
                </button>
            </div>
        </div>
    );
}